import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PageHeader } from "../../shared/ui/PageHeader";
import { useIsMobile } from "../../shared/hooks/useIsMobile";
import { usePedido, usePedidos } from "./hooks";
import { PedidoFilters } from "./components/PedidoFilters";
import { PedidoTable } from "./components/PedidoTable";
import { PedidoMobileList } from "./components/PedidoMobileList";
import { PedidoDrawer } from "./components/PedidoDrawer";

export default function Pedidos() {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { pedidoId } = useParams();

  const [origin, setOrigin] = useState("");
  const [status, setStatus] = useState("");
  const [statusDate, setStatusDate] = useState(null);
  const [search, setSearch] = useState("");

  const statusDateParam = useMemo(
    () => (statusDate ? statusDate.format("YYYY-MM-DD") : undefined),
    [statusDate],
  );

  const { data: pedidos = [], isLoading } = usePedidos({
    origin,
    status,
    statusDate: statusDateParam,
    search,
  });
  const { data: selectedPedido, isLoading: detailsLoading } = usePedido(pedidoId);

  const hasActiveFilters = Boolean(origin || status || statusDate || search);

  const sortedPedidos = useMemo(
    () =>
      [...pedidos].sort((a, b) => {
        const dateA = new Date(a.createdAt).getTime();
        const dateB = new Date(b.createdAt).getTime();
        if (dateA !== dateB) return dateB - dateA;
        return Number(b.orderNumber || 0) - Number(a.orderNumber || 0);
      }),
    [pedidos],
  );

  const openDetails = (id) => navigate(`/pedidos/${id}`);
  const closeDetails = () => navigate("/pedidos");

  const clearFilters = () => {
    setOrigin("");
    setStatus("");
    setStatusDate(null);
    setSearch("");
  };

  return (
    <div className="te-page-wrap te-stack">
      <PageHeader
        title="Pedidos"
        subtitle="Consulte os pedidos com filtros simples por origem, status e busca."
        metricLabel="Pedidos visíveis"
        metricValue={sortedPedidos.length}
      />

      <PedidoFilters
        origin={origin}
        setOrigin={setOrigin}
        status={status}
        setStatus={setStatus}
        statusDate={statusDate}
        setStatusDate={setStatusDate}
        search={search}
        setSearch={setSearch}
        hasActiveFilters={hasActiveFilters}
        onClear={clearFilters}
      />

      {isMobile ? (
        <PedidoMobileList
          pedidos={sortedPedidos}
          loading={isLoading}
          onSelect={openDetails}
        />
      ) : (
        <PedidoTable
          pedidos={sortedPedidos}
          loading={isLoading}
          onSelect={openDetails}
        />
      )}

      <PedidoDrawer
        open={Boolean(pedidoId)}
        pedido={selectedPedido}
        loading={detailsLoading}
        onClose={closeDetails}
      />
    </div>
  );
}
